// This is for bootstrap's dropdowns to imitate <select> behaviour: select an active on click
import { BaseElements, BaseObject, BaseService, BaseInjector } from '../../js/base';
import { querySelectorAll, querySelector } from '../../utility/utils/index';
const events = {
    change: new Event('change')
};

class Texts extends BaseObject {}

class ClassList extends BaseObject {
    current = 'current';
    active = 'active';
}

class Selectors extends BaseObject {
    dropdownItem = '.dropdown-item';
    dropdownToggle = '.dropdown-toggle, .tabs-toggle';
    formControl = '.dropdown-selectable--form-control';
    dropdownMenu = '.dropdown-menu';
}
class Elements extends BaseElements<Selectors> {
    dropdownToggle: HTMLElement;
    dropdownMenu: HTMLElement;
    constructor(selectors: Selectors) {
        super(selectors, false);
    }
    setWrapper(wrapper: HTMLElement) {
        this.wrapper = wrapper;
        this.initElements();
    }
    initElements() {
        this.initElementsByLoop(this.wrapper);
    }
    get dropdownItems(): NodeListOf<HTMLAnchorElement> {
        return querySelectorAll(this.selectors.dropdownItem, this.wrapper);
    }
}

interface SelectableDropdown extends BaseService<Selectors, Elements, ClassList, Texts> { }

@BaseInjector(Selectors, Elements, ClassList, Texts)
class SelectableDropdown {
    constructor(readonly wrapper: HTMLElement) {}
    protected keydownHandlerBinded: (Event) => void;
    lastMatchingIndex: number = 0;
    currentOptionIndex: number;
    prevTypedChar: string = "";
    currentTypedChar: string = "";
    timeOut: NodeJS.Timeout;
    
    initialize(): void {        
        this.elements.setWrapper(this.wrapper);
        this.addEventListeners();
        this.keydownHandlerBinded = this.keydownHandler.bind(this);
    }
    
    addEventListeners() {
        this.wrapper.addEventListener('click', this.dropdownItemClick.bind(this));
        $(this.wrapper).on('show.bs.dropdown', () => {
            this.wrapper.addEventListener('keydown', this.keydownHandlerBinded);
        });
        $(this.wrapper).on('hide.bs.dropdown', () => {
            this.wrapper.removeEventListener('keydown', this.keydownHandlerBinded);
            if (this.currentOptionIndex && this.elements.dropdownItems[this.currentOptionIndex].classList.contains('current')) {
                this.elements.dropdownItems[this.currentOptionIndex].click();
            }
        });
    }

    dropdownItemClick(e) {
        let target = e.target;

        if(!(target &&  target.classList.contains('dropdown-item'))) {
            target = e.target.closest('.dropdown-item');
        }

        if (target && target.classList.contains('dropdown-item')) {
            if (target.getAttribute('href') === '#') {
                e.preventDefault();
            }
            this.lastMatchingIndex = 0;
            
            this.elements.dropdownToggle.textContent = target.textContent;

            this.elements.dropdownItems.forEach((item) => {
                if (target !== item) {
                    item.classList.remove(this.classList.active);
                    item.classList.remove(this.classList.current);
                    item.setAttribute('aria-selected', 'false');
                }
            })
            target.classList.add(this.classList.current);
            target.setAttribute('aria-selected', 'true');
            const formControl = target.closest(this.selectors.formControl);
            if (formControl) {
                let input = formControl.querySelector('input');
                input.value = target.dataset.value;
                input.dispatchEvent(events.change);
            }
            $(this.elements.dropdownToggle).dropdown('toggle');
        }
    }

    keydownHandler(e) {
        if (e.key) {
            const typedChar = e.key.toLowerCase();
            if (this.prevTypedChar !== typedChar) {
                this.lastMatchingIndex = 0;
                this.currentTypedChar += typedChar;
            } else {          
                this.currentTypedChar = typedChar;
            }
            const matchingOptions = Array.from(this.elements.dropdownItems).filter((option) => {
                return option.textContent.toLowerCase().trim().startsWith(this.currentTypedChar)}
            );
            if (matchingOptions.length) {
                if (this.lastMatchingIndex === matchingOptions.length) {
                    this.lastMatchingIndex = 0;
                }
                let value = matchingOptions[this.lastMatchingIndex]
                this.currentOptionIndex = Array.from(this.elements.dropdownItems).indexOf(value);
                const currentOption = this.elements.dropdownItems[this.currentOptionIndex];
                this.elements.dropdownItems.forEach(option => {
                    if (option !== currentOption) {
                        option.classList.remove(this.classList.current);
                    }
                });
                currentOption.classList.add(this.classList.current);
                currentOption.focus();
                this.lastMatchingIndex += 1;
            }
            this.prevTypedChar = typedChar;
        }
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
            this.currentTypedChar = "";
        }, 1000);
    }
}

export default SelectableDropdown;

export {
    Elements as SelectableDropdownElements,
    Selectors as SelectableDropdownSelectors,
    ClassList as SelectableDropdownClassList,
    Texts as SelectableDropdownTexts
}